import React from 'react'
import { useTranslation } from 'react-i18next'

import Concepts from 'components/Landing/Concepts'
import Hero from './Hero'
import Features from './Features'
import Testimonials from './Testimonials'
import LandingBox from './LandingBox'
import Method from './Method'
import ContactUs from './ContactUs'

function Home() {
  const { t } = useTranslation()

  return (
    <div className="home">
      <div className="home__wrapper">
        <Hero />
        <LandingBox className="landing-box">
          <div className="landing-box__title">{t('landing.home.box_title')}</div>
          <div className="landing-box__separator" />
          <div className="landing-box__text">{t('landing.home.box_text')}</div>
        </LandingBox>
        <Features />
        <Concepts />
        <Testimonials />
        <Method />
        <ContactUs />
      </div>
    </div>
  )
}

export default Home
